import { navigate } from "gatsby";
import parse from "html-react-parser";
import React from "react";
import PropTypes from "prop-types";

import {
  arrowLeft,
  callIcon,
  viewTickets,
} from "../../assets/images/icons";
import {
  onBackPressed,
  exitFromWebView,
  ingestData,
  isMobileBridgePresent,
  openURL,
  triggerNavigation,
} from "../../bridges/BridgeServices";
import Chatbot from "../../components/Chatbot/Chatbot";
import useGetIVRDetails from "../../hooks/useGetIVRDetails";
import {
  EVENTS,
  OPEN_URL_ACTION_TYPE,
} from "../../utils/constants";
import { isTokenPresent } from "../../utils/cookieHelper";
import MobileContactSupport from "../MobileContactSupport/mobileContactSupport";
import SearchInput from "../SearchInput/searchInput";
import "./mobileHeader.scss";

const VIEW_TICKET_URL =
  "phonepe-wealth://app/help/viewTickets";

const MobileHeader = ({ variant = "", faqTitle }) => {
  const ivrData = useGetIVRDetails();

  const handleTalkToUsOnClick = () => {
    openURL(
      `tel:${ivrData?.phoneNumber}`,
      "",
      OPEN_URL_ACTION_TYPE.CALL
    );
    ingestData({
      name: EVENTS.TALK_TO_US_CLICKED,
      data: {
        active: ivrData?.isEnabled,
        faqTitle,
      },
    });
  };

  const handleOnBackPress = () => {
    //TODO: Remove exitWebview and navigate(-1) when the adoption is 100%
    if (Freshbot.onBackPressed) {
      onBackPressed();
    } else if (Freshbot.exitWebview) {
      exitFromWebView();
    } else {
      //Adding this as a fallback in case any of the mobile bridges are not present.
      navigate(-1);
    }
  };

  return (
    <>
      <div
        className={`mobile-header-container ${
          variant === "compressed"
            ? "compressed-mobile-header"
            : ""
        }`}
      >
        <div className="mobile-heading-wrapper">
          <div
            className="back-arrow"
            onClick={() => {
              handleOnBackPress();
            }}
          >
            {parse(arrowLeft)}
          </div>

          <p className="header-heading">Help Center</p>

          <SearchInput />
        </div>
        <Chatbot />
        {isTokenPresent() && variant !== "compressed" && (
          <>
            <div className="btn-wrapper">
              <div className="contact-support">
                <MobileContactSupport
                  supportBtnClassName={`${
                    isMobileBridgePresent()
                      ? "mobile-contact-support"
                      : "disabled-mobile-contact-support"
                  }`}
                />
              </div>
              <div className="view-tickets">
                {parse(viewTickets)}
                <a
                  onClick={() => {
                    triggerNavigation({
                      deepLink: VIEW_TICKET_URL,
                    });
                  }}
                  rel="noreferrer"
                  className="view-tickets-btn"
                >
                  View Tickets
                </a>
              </div>
            </div>

            {ivrData?.isEnabled && (
              <a
                onClick={() => handleTalkToUsOnClick()}
                className={`talk-to-us-wrapper ${
                  ivrData?.isAvailable ? "" : "disabled"
                }`}
              >
                {parse(callIcon)}
                <div className="talk-to-us-text-wrapper">
                  <p className="talk-to-us-text-header">
                    Talk To Us
                  </p>
                  <p className="talk-to-us-text-desc">
                    {`Weekdays ${ivrData?.businessStartTime} to ${ivrData?.businessEndTime}`}
                  </p>
                </div>
                <p className="talk-to-us-time-wrapper">
                  {ivrData?.isAvailable
                    ? `Wait time: ${ivrData?.expectedWaitTime} min`
                    : "Not Available"}
                </p>
              </a>
            )}
          </>
        )}
      </div>
    </>
  );
};

MobileHeader.propTypes = {
  variant: PropTypes.string,
  faqTitle: PropTypes.string,
};

export default MobileHeader;
